import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import "@mantine/core/styles.css";

import "./App.css";

import "swiper/css";

import AOS from "aos";
import "aos/dist/aos.css";

import Layout from "./components/common/Layout";
import Home from "./pages/home";
import Transform from "./pages/transform";
import AdminLogin from "./pages/login";
import Dashboard from "./pages/admin";
import AContact from "./pages/admin/contact";
import AOneContact from "./pages/admin/contact/detail";
import AOneBranch from "./pages/admin/branch/detail";
import ABranch from "./pages/admin/branch";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/transform" element={<Transform />} />
          <Route path="admin">
            <Route path="login" element={<AdminLogin />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="inquiry" element={<AContact />} />
            <Route path="inquiry/:id" element={<AOneContact />} />
            <Route path="branch" element={<ABranch />} />
            <Route path="branch/:id" element={<AOneBranch />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
